import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {timeout} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@services/infra/config.service';
import {VerificationResource} from '@services/resource/verification-resource';
import {ClientConfig} from '@app/client-config';
import {ErrorService} from '@services/error.service';

@Injectable({
  providedIn: 'root',
})
export class VerificationnoteService {
  constructor(
    private readonly errors: ErrorService,
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
  ) {}

  public verifyProduct(productId: string): Observable<VerificationResource> {
    const url = `${this.conf.backendUrl}/v1/verificationnote?productId=${productId}`;
    return this.http.get<VerificationResource>(url, {}).pipe(timeout(ClientConfig.timeout), this.errors.withErrorHandler());
  }
}
